<template>
  <div>
    <div class="mainContainer" style="width: 1400px;background-color: #FFFFFF">
      <div id="map"></div>
      <div style="padding: 20px;">
        <h2>联系我们</h2>
        <p>地址：河北省三河市燕郊高新区学院街465号</p>
        <p>邮政编码 :101601</p>
        <p>电子邮箱 :fzgis@163.com</p>
        <button @click="navigateToLocation">去往此地</button>
      </div>
    </div>
  </div>
</template>

<script>
import L from 'leaflet';
import 'leaflet/dist/leaflet.css';
// 修复Leaflet默认图标路径问题
delete L.Icon.Default.prototype._getIconUrl;

L.Icon.Default.mergeOptions({
  iconRetinaUrl: 'leaflet-images/marker-icon-2x.png',
  iconUrl: 'leaflet-images/marker-icon.png',
  shadowUrl: 'leaflet-images/marker-shadow.png',
});

export default {
  name: "about",
  data() {
    return {
      companyCoords: {
        lat: 39.962240,
        lon: 116.7920
      }
    };
  },
  mounted() {
    this.initializeMap();
  },
  methods: {
    initializeMap() {
      const map = L.map('map').setView([this.companyCoords.lat, this.companyCoords.lon], 13);

      L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
        maxZoom: 19,
      }).addTo(map);
      const customIcon = L.icon({
        iconUrl: 'public/img/fangzailogo.jpg', // 替换为你自定义图片的路径
        iconSize: [32, 32], // 控制图标的大小
        iconAnchor: [16, 32], // 控制图标的锚点
        popupAnchor: [0, -32] // 控制弹出框的位置
      });

      const companyMarker = L.marker([this.companyCoords.lat, this.companyCoords.lon]).addTo(map)
          .bindPopup('我们的位置')
          .openPopup();
    },
    navigateToLocation() {
      const directionsUrl = `https://www.google.com/maps/dir/?api=1&destination=${this.companyCoords.lat},${this.companyCoords.lon}`;
      window.open(directionsUrl, '_blank');
    }
  }
};
</script>

<style scoped>
.content ul li {
  letter-spacing: 1px !important;
  width: 100% !important;
}
#map {
  height: 500px;
  width: 1400px;
  z-index: 1;
}
</style>
